/**
 * Abstract class for actions to edit a rule template, like
 * adding a rule template by example.
 *
 * Those actions are then processed by the {@link ForecastEditorDocumentState}.
 *
 * @abstract
 * @param {RuleTemplate} ruleTemplate - Rule template upon
 *   which to act
 */
export default class AbstractRuleTemplateAction {
	constructor({ ruleTemplate }) {
		this._ruleTemplate = ruleTemplate;
	}

	appendTo(_bulkRuleTemplateAction) {
		throw new Error("Should be overridden");
	}

	perform(fn) {
		fn(this);
	}
}
